import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const money = (n) => `₹${n.toLocaleString("en-IN")}`;

export default function Cart() {
  const { cart, update, remove, total } = useStore();
  const nav = useNavigate();

  if (!cart.length) return (
    <div className="cart-page empty" data-testid="cart-page-empty">
      <ShoppingBag size={40} />
      <h1>Your bag is empty.</h1>
      <p>Everything worth carrying begins with a first piece.</p>
      <Link to="/shop" className="lux-cta" data-testid="cart-shop-cta">Browse the collection →</Link>
    </div>
  );

  return (
    <div className="cart-page" data-testid="cart-page">
      <header className="cart-head">
        <span className="lux-eyebrow dark">Your bag</span>
        <h1>{cart.length} piece{cart.length === 1 ? "" : "s"} · {money(total)}</h1>
      </header>
      <div className="cart-layout">
        <div className="cart-list">
          {cart.map((i, n) => (
            <article key={`${i.id}-${i.size}-${i.color || ""}`} className="cart-line" data-testid={`cart-line-${i.id}-${i.size}`}>
              <img src={i.image} alt={i.name} />
              <div className="cart-line-body">
                <p className="lux-card-cat">{i.category}</p>
                <h3>{i.name}</h3>
                <p className="cart-line-meta" data-testid={`cart-line-meta-${n}`}>Size {i.size}{i.color ? ` · ${i.color}` : ""} · {money(i.price)}</p>
                <div className="qty-row">
                  <button onClick={() => update(n, -1)} data-testid={`cart-decrease-${i.id}-${i.size}`} aria-label="Decrease"><Minus size={13} /></button>
                  <span data-testid={`cart-qty-${i.id}-${i.size}`}>{i.qty}</span>
                  <button onClick={() => update(n, 1)} data-testid={`cart-increase-${i.id}-${i.size}`} aria-label="Increase"><Plus size={13} /></button>
                  <button className="line-remove" onClick={() => remove(n)} data-testid={`cart-remove-${i.id}-${i.size}`}><Trash2 size={13} /> Remove</button>
                </div>
              </div>
              <strong className="cart-line-total">{money(i.price * i.qty)}</strong>
            </article>
          ))}
        </div>
        <aside className="cart-summary" data-testid="cart-summary">
          <h2>Order summary</h2>
          <div className="row"><span>Subtotal</span><strong>{money(total)}</strong></div>
          <div className="row"><span>Shipping</span><strong>{total >= 2500 ? "Free" : "Calculated at checkout"}</strong></div>
          <div className="row total"><span>Estimated total</span><strong>{money(total)}</strong></div>
          <button className="lux-cta full" onClick={() => nav("/checkout")} data-testid="checkout-button">Continue to checkout →</button>
          <Link to="/shop" className="lux-text-link centered">or keep shopping</Link>
        </aside>
      </div>
    </div>
  );
}
